import React, { useEffect, useState } from 'react';
import { beautify } from '../../helpers/str';

const InputTextArea = ({ config, onChange, defaultValue }) => {
    const [value, setValue] = useState(defaultValue || '');

    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);

    const handleChange = (e) => {
        const val = e.target.value;
        setValue(val);
        if (onChange) {
            onChange(val, e.target.name);
        }
    };

    return (
        <textarea
            autoFocus={config.autoFocus}
            readOnly={config.readOnly}
            placeholder={config.placeholder || beautify(config.name)}
            className={`control ${config.className || ''}`}
            name={config.name}
            onChange={handleChange}
            value={value || ''}
            rows={config.rows}></textarea>
    );
};

export default InputTextArea;
